/* eslint-disable react-hooks/exhaustive-deps */
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import type { RootState, AppDispatch } from "./store";
import { useEffect, useState } from "react";
import { CognitoJwtPayload } from "../features/console/consoleSlice";
import { useLazyJwtProcessorQuery } from "../services/serverless";
import { getUserSessionItem, refreshToken } from "..";
import { CognitoOidcConfig } from "../CognitoOidcConfig";
import { useLocation, useNavigate } from "react-router-dom";

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export function useValidatedUserPayload() {
  const [userSession, setUserSession] = useState<{
    payload: CognitoJwtPayload | null;
    isAdmin: boolean | null;
    cognitoGroups: string[] | null;
  }>({ payload: null, isAdmin: null, cognitoGroups: null });

  const [jwtProcessorQuery] = useLazyJwtProcessorQuery();
  const navigate = useNavigate();

  const idTokenObj = getUserSessionItem("idToken");
  const location = useLocation();
  useEffect(() => {
    async function fetchPayload() {
      await refreshToken();
      try {
        if (idTokenObj) {
          jwtProcessorQuery({
            clientId: CognitoOidcConfig.clientId,
            idToken: idTokenObj,
          })
            .unwrap()
            .then((validatedUserPayload) => {
              setUserSession({
                payload: validatedUserPayload,
                isAdmin:
                  validatedUserPayload &&
                  validatedUserPayload["cognito:groups"].includes(
                    "Administrator",
                  ),
                cognitoGroups:
                  validatedUserPayload &&
                  validatedUserPayload["cognito:groups"],
              });
            });
        } else {
          navigate(
            `/login?redirect_uri=${encodeURIComponent(`${location.pathname}${location.search}`)}`,
          );
        }
      } catch (e) {
        console.error(e); //if there is an error, try again. TODO: change to more elegant implementation
        if (idTokenObj) {
          jwtProcessorQuery({
            clientId: CognitoOidcConfig.clientId,
            idToken: idTokenObj,
          })
            .unwrap()
            .then((validatedUserPayload) => {
              setUserSession({
                payload: validatedUserPayload,
                isAdmin:
                  validatedUserPayload &&
                  validatedUserPayload["cognito:groups"].includes(
                    "Administrator",
                  ),
                cognitoGroups:
                  validatedUserPayload &&
                  validatedUserPayload["cognito:groups"],
              });
            });
        } else {
          navigate(
            `/login?redirect_uri=${encodeURIComponent(`${location.pathname}${location.search}`)}`,
          );
        }
      }
    }
    fetchPayload();
  }, []);

  return userSession;
}
